import React from "react";

const InitiativeTable = ({ initiativeTable, setInitiativeTable }) => {
  const handleInputChange = (rowIndex, field, value) => {
    const updatedData = [...initiativeTable];
    updatedData[rowIndex][field] = value;
    setInitiativeTable(updatedData);
  };

  const addRow = () => {
    setInitiativeTable([
      ...initiativeTable,
      {
        initiativeName: "",
        typeOfSupport: "",
        startEndDate: "",
        status: "",
        priorityCountry: "",
        priorityDisease: "",
        description: "",
      },
    ]);
  };

  const removeRow = () => {
    if (initiativeTable.length > 1) {
      setInitiativeTable(initiativeTable.slice(0, -1));
    }
  };

  const supportOptions = ["Funded", "Led", "Partnered"];
  const statusOptions = ["Ongoing", "Completed"];
  const countryOptions = ["India", "USA", "Germany", "Other"];

  return (
    <div>
      <div style={{ marginTop: "20px", border: "1px solid #000", borderRadius: "8px", overflow: "hidden", width: "100%" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#d0c5ca", color: "#000" }}>
              <th style={tableHeaderStyle}>Initiative Name</th>
              <th style={tableHeaderStyle}>Type of Support</th>
              <th style={tableHeaderStyle}>Start/End Date</th>
              <th style={tableHeaderStyle}>Status</th>
              <th style={tableHeaderStyle}>Priority Country</th>
              <th style={tableHeaderStyle}>Priority Disease</th>
              <th style={tableHeaderStyle}>Description</th>
            </tr>
          </thead>
          <tbody>
            {initiativeTable.map((row, index) => (
              <tr key={index}>
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    value={row.initiativeName}
                    onChange={(e) => handleInputChange(index, "initiativeName", e.target.value)}
                    style={inputFieldStyle}
                  />
                </td>
                <td style={tableCellStyle}>
                  <select
                    value={row.typeOfSupport}
                    onChange={(e) => handleInputChange(index, "typeOfSupport", e.target.value)}
                    style={inputFieldStyle}
                  >
                    <option value="">Select</option>
                    {supportOptions.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    value={row.startEndDate}
                    onChange={(e) => handleInputChange(index, "startEndDate", e.target.value)}
                    style={inputFieldStyle}
                  />
                </td>
                <td style={tableCellStyle}>
                  <select
                    value={row.status}
                    onChange={(e) => handleInputChange(index, "status", e.target.value)}
                    style={inputFieldStyle}
                  >
                    <option value="">Select</option>
                    {statusOptions.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </td>
                <td style={tableCellStyle}>
                  <select
                    value={row.priorityCountry}
                    onChange={(e) => handleInputChange(index, "priorityCountry", e.target.value)}
                    style={inputFieldStyle}
                  >
                    <option value="">Select</option>
                    {countryOptions.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    value={row.priorityDisease}
                    onChange={(e) => handleInputChange(index, "priorityDisease", e.target.value)}
                    style={inputFieldStyle}
                  />
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    value={row.description}
                    onChange={(e) => handleInputChange(index, "description", e.target.value)}
                    style={inputFieldStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ display: "flex", justifyContent: "center", marginTop: "10px", gap: "10px" }}>
        <button onClick={removeRow} style={removeButtonStyle}>- Remove</button>
        <button onClick={addRow} style={addButtonStyle}>+ Add More</button>
      </div>
    </div>
  );
};

// Reuse styling
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputFieldStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default InitiativeTable;
